import { ChannelMask } from './channel-mask.js';
import { LogLevel, getPriorityFromLogLevel } from './log-level.js';
import { isNullOrUndefined } from './null-safety.js';

export abstract class Logger {
  constructor(
    private channels: ChannelMask | null,
  ) {}

  abstract get logLevel(): LogLevel

  setChannels(mask: ChannelMask) {
    this.channels = mask;
  }

  clearChannels(): void {
    this.channels = null;
  }

  protected isChannelOn(channel: string | null = null): boolean {
    if(isNullOrUndefined(channel)) {
      return true;
    }

    return this.channels?.isOn(channel) ?? true;
  }

  protected meetsPriority(priority: LogLevel): boolean {
    return getPriorityFromLogLevel(priority) >= getPriorityFromLogLevel(this.logLevel);
  }

  abstract logDebug(
    message: string,
    args?: {
      channel?: string,
    }
  ): void

  abstract logInfo(
    message: string,
    args?: {
      channel?: string,
    }
  ): void

  abstract logWarning(
    warning: string,
    args?: {
      channel?: string,
    }
  ): void

  abstract logError(
    error: string,
    args?: {
      channel?: string,
      stackTrace?: string,
    }
  ): void

  abstract logException(
    exception: string,
    args?: {
      channel?: string,
      stackTrace?: string,
    }
  ): void

  abstract logFatal(
    fatalException: string,
    args?: {
      channel?: string,
      stackTrace?: string,
    }
  ): void
}
